import { ReactElement } from 'react';
import { ICON_DEFAULTS, IconProps } from './types';

export function IconBinoculars({
  size = ICON_DEFAULTS.size,
  color = ICON_DEFAULTS.color,
  filled = ICON_DEFAULTS.filled,
  className = ICON_DEFAULTS.className,
}: IconProps): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
    >
      {filled ? (
        <path
          d="M29.65 18.9874C29.65 18.9749 29.6375 18.9749 29.6375 18.9624C29.5568 18.7353 29.4608 18.5139 29.35 18.2999L24.1625 6.47489C24.1105 6.36276 24.0385 6.26108 23.95 6.17489C23.5784 5.80261 23.1371 5.50725 22.6513 5.30574C22.1655 5.10422 21.6447 5.00049 21.1187 5.00049C20.5928 5.00049 20.072 5.10422 19.5861 5.30574C19.1003 5.50725 18.659 5.80261 18.2875 6.17489C18.1959 6.26693 18.1233 6.37614 18.074 6.49625C18.0247 6.61637 17.9995 6.74504 18 6.87489V10.4999H14V6.87489C14.0004 6.74504 13.9753 6.61637 13.9259 6.49625C13.8766 6.37614 13.8041 6.26693 13.7125 6.17489C13.3409 5.80261 12.8996 5.50725 12.4138 5.30574C11.928 5.10422 11.4072 5.00049 10.8812 5.00049C10.3553 5.00049 9.83446 5.10422 9.34864 5.30574C8.86282 5.50725 8.42151 5.80261 8.04997 6.17489C7.96142 6.26108 7.8894 6.36276 7.83747 6.47489L2.64997 18.2874C2.53915 18.5014 2.44309 18.7228 2.36247 18.9499C2.36247 18.9624 2.34997 18.9624 2.34997 18.9749C2.05534 19.7993 1.9447 20.6782 2.0258 21.5499C2.1069 22.4216 2.37779 23.265 2.81944 24.0209C3.2611 24.7768 3.86283 25.4269 4.5824 25.9256C5.30197 26.4243 6.12196 26.7594 6.98481 26.9076C7.84766 27.0557 8.73248 27.0132 9.57717 26.7831C10.4219 26.553 11.206 26.1408 11.8744 25.5754C12.5429 25.0101 13.0796 24.3053 13.4468 23.5106C13.814 22.7158 14.0028 21.8504 14 20.9749V12.4999H18V20.9749C17.9954 21.8509 18.1826 22.7172 18.5486 23.5131C18.9146 24.309 19.4504 25.0151 20.1184 25.5818C20.7864 26.1485 21.5703 26.562 22.4152 26.7934C23.2601 27.0247 24.1454 27.0683 25.0089 26.921C25.8724 26.7737 26.6932 26.4391 27.4136 25.9407C28.134 25.4423 28.7365 24.7922 29.1788 24.0361C29.6211 23.2799 29.8925 22.4361 29.9739 21.5639C30.0553 20.6917 29.9447 19.8123 29.65 18.9874ZM11.7625 22.3624C11.3906 23.344 10.6478 24.1401 9.69428 24.5789C8.74076 25.0178 7.65294 25.0643 6.66547 24.7083C5.67799 24.3524 4.87001 23.6225 4.41579 22.6762C3.96157 21.7299 3.89753 20.643 4.23747 19.6499L4.46247 19.1374C4.87886 18.3484 5.54703 17.7213 6.36077 17.3557C7.1745 16.9902 8.08709 16.9071 8.95347 17.1197C9.81984 17.3324 10.5903 17.8285 11.1423 18.5293C11.6943 19.2301 11.9962 20.0953 12 20.9874C12.0017 21.4561 11.9213 21.9214 11.7625 22.3624ZM25.3625 24.7624C24.7582 24.9813 24.1101 25.0514 23.473 24.9667C22.8359 24.8821 22.2286 24.6451 21.7025 24.276C21.1764 23.9069 20.747 23.4164 20.4507 22.8461C20.1543 22.2759 19.9997 21.6426 20 20.9999C20.0038 20.1078 20.3057 19.2426 20.8577 18.5418C21.4097 17.841 22.1801 17.3449 23.0465 17.1322C23.9128 16.9196 24.8254 17.0027 25.6392 17.3682C26.4529 17.7338 27.1211 18.3609 27.5375 19.1499L27.7625 19.6624C28.1165 20.6571 28.0629 21.7515 27.6133 22.7069C27.1638 23.6623 26.3546 24.4012 25.3625 24.7624Z"
          fill={color}
        />
      ) : (
        <>
          <path d="M13 11.5H19" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M28.7 19.2874L23.2375 6.8749C22.6735 6.31689 21.9121 6.00391 21.1187 6.00391C20.3254 6.00391 19.564 6.31689 19 6.8749V20.9999"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.9998 20.9999V6.8749C12.4358 6.31689 11.6744 6.00391 10.8811 6.00391C10.0877 6.00391 9.3263 6.31689 8.7623 6.8749L3.2998 19.2874"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 26C10.7614 26 13 23.7614 13 21C13 18.2386 10.7614 16 8 16C5.23858 16 3 18.2386 3 21C3 23.7614 5.23858 26 8 26Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24 26C26.7614 26 29 23.7614 29 21C29 18.2386 26.7614 16 24 16C21.2386 16 19 18.2386 19 21C19 23.7614 21.2386 26 24 26Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
    </svg>
  );
}
